const LDClient = window ? window.LDClient : null;

class LDClientWrapper {
    constructor() {
        this.client = undefined
    }

    initialize() {
        const clientId = window.apr && window.apr.launch_darkly_client_id ? window.apr.launch_darkly_client_id : '';

        if (LDClient && window.Promise && clientId && !this.client) {
            const anonymousUserContext = {
                kind: 'user',
                anonymous: true,
            }
            this.client = LDClient.initialize(clientId, anonymousUserContext);
        }
    }

    close() {
        if (this.client) {
            this.client.close()
        }
    }

    getFeatureFlag(flag, defaultValue = false) {
        if (this.client === undefined) {
            return false
        }
        return this.client.variation(flag, defaultValue);
    }
}

const ldClientWrapper = new LDClientWrapper()
export default ldClientWrapper
